import {
  useEffect, useState
} from 'react';

import get from 'lodash/get';

import { shouldDisablePrometheus, sinatraOrigin } from '../../config';
import keycloakService from '../../keycloak_service';

export const fetchPrometheusQuery = (query) => {
  if (shouldDisablePrometheus) {
    throw new Error('Prometheus is disabled.');
  }

  if (!query) {
    throw new Error('No query provided.');
  }

  return fetch(
    `${sinatraOrigin}/v1/metrics/api/v1/query?query=${encodeURIComponent(
      query,
    )}`,
    { headers: { Authorization: keycloakService.getAuthHeader() } }
  )
    .then(response => response.json())
    .then((response) => {
      if (response && response.status === 'success') {
        const resultSets = get(response, 'data.result', []);

        if (!resultSets?.length) {
          return { values: [] }
        }
        if (resultSets?.length > 1 || resultSets?.length === 1 && query.replaceAll(" ", "").includes("by(namespace)")) {
          const values = resultSets.map(({ metric, value }) => {
            return ({
              namespace: metric?.namespace, topic: metric?.topic, value: value[1],
            })
          })

          if (!values) {
            throw new Error("Couldn't load Prometheus data");
          }

          return { values };
        }

        const value = resultSets[0]?.value;

        if (!value) {
          throw new Error("Couldn't load Prometheus data");
        }

        return { values: value };
      }

      throw new Error("Couldn't load Prometheus data")
    })
    .catch((e) => {
      console.error(e);
    })
}

const usePrometheusQuery = (query) => {
  const [isLoading, setLoading] = useState(false);
  const [currentData, setCurrentData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetchPrometheusQuery(query).then((res) => {
      setCurrentData(res.values);
      setLoading(false);
    }).catch((e) => {
      setError(e?.msg ? e.msg : e);
      setLoading(false);
    })
  }, [query]);

  return {
    data: currentData,
    error: error?.message,
    isLoading,
  }
}

export default usePrometheusQuery;
